module.exports = __webpack_public_path__ + "media/images/japan/arrowle-risk-634f1d772cd7a26e8c8fcaca434e6b98.svg";